export default {
  STN001: 1, // Dư dự toán
  STN002: 2, // Dư cam kết chi
  STN003: 3 // Dư tạm ứng
};
